import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { getUser } from '@portal-workspace/grow-ui-library';
import { navigationUrlForNewApplication } from '../service/navigation-urls';
import { Priviledges} from '@portal-workspace/grow-shared-library';



export const adminCompanyAdminAndAnalystAccessGuard = () => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const allowedUserPrivileges: Priviledges =  [
      'admin',
      'companyadmin',
      'analyst',
      'operations',
      'operations24',
      'credit',
      'salesAM',
      'salesBDM'
    ];

    const user = getUser()
    if (user?.priviledges.some(priviledge => allowedUserPrivileges.includes(priviledge))) {
      return true;
    }
    return router.navigate(navigationUrlForNewApplication())
  }
}

